const skuTransform = (newSkuData) => {
  return newSkuData?.map(
    ({
      id,
      skuUrl,
      price: {
        listPrice,
        currency: { code, symbol } = {},
        onSale,
        salePrice,
      } = {},
      size,
      color,
      available,
      inseam,
      styleId,
      styleNumber,
    }) => ({
      size,
      inseam: inseam || null,
      id,
      productId: skuUrl?.split?.("?")?.[0]?.split?.("_/")[1],
      "style-number": styleNumber,
      "price-details": {
        "currency-symbol": symbol,
        "currency-code": code,
        "list-price": listPrice,
        "on-sale": onSale,
        "sale-price": salePrice,
      },
      "color-code": color?.code,
      // "in-store": false,
      "style-id": styleId,
      available,
    })
  );
};

export default skuTransform;
